/**
 * 작성자 : 홍선영
 * 날짜 : 2025.01.03
 * 기능 : (사내)사내관리-우수사원
 */

import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { ContentsContainerRoot } from '../../../assets/styles/ContentsContainerRoot';
import { useEffect, useState } from 'react';
import List from './list';
import Form from './form';
import GetFetchStatus from '../../../hooks/GetFetchStatus';
import { useRecoilValue } from 'recoil';
import { IUser, userState } from '../../../atoms';
import BackButton from '../../../components/BackButton';
import { useTranslation } from 'react-i18next';
import useBackHistory from '../../../hooks/useBackHistory';

const Root = styled(ContentsContainerRoot)`
  &.hideRoot {
    visibility: hidden;
    position: absolute;
  }

  .table > .tbody > .tr > div {
    color: var(--text-secondary);
  }

  .rangePickerWrapper > div {
    left: 71%;
  }

  .formTitle {
    padding: 0 0.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: var(--text-primary);
  }
  .inputFormsWrapper {
    border-bottom: 1px solid var(--outline);
    padding: 0.5rem;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    .table {
      height: fit-content;
    }
  }
`;

export interface IExellentUser {
  cSeq: number;
  userName: string;
  cCd: string;
  cDate: string;
  userId: string;
  cContents: string;
  partCd: string;
  partCdName: string;
  positionCd: string;
  positionName: string;
  wDate: string;
  writer: string;
  eDate: string;
  editor: string;
  rowKey: string;
}

export const INIT_ROW_STATE = {
  cSeq: 0,
  userName: '',
  cCd: '',
  cDate: '',
  userId: '',
  cContents: '',
  partCd: '',
  partCdName: '',
  positionCd: '',
  positionName: '',
  wDate: '',
  writer: '',
  eDate: '',
  editor: '',
  rowKey: '',
};

const ExcellentEmployee = () => {
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const userInfo = useRecoilValue<IUser>(userState);
  const [viewTable, setViewTable] = useState<boolean>(true);
  const [rowState, setRowState] = useState<IExellentUser>(INIT_ROW_STATE);
  const [isNewAdd, setIsNewAdd] = useState(true);
  const { data: userList, isLoading, isError, refetch } = GetFetchStatus({ path: '/cexcellent', req: { cCd: userInfo.hCd }, hCdOnly: { value: true, key: 'cCd' } });
  const [tableState, setTableState] = useState<IExellentUser[] | null>(null);

  useEffect(() => {
    if (!isNewAdd) setViewTable(false);
  }, [isNewAdd]);

  const addBtnAction = () => {
    setIsNewAdd(true);
    if (size.innerSize.W <= 1024) setViewTable(false);
  };

  const backToMain = () => {
    setIsNewAdd(true);
    setViewTable(true);
  };

  const { onBackPrev } = useBackHistory({ isOpen: !viewTable, onPrev: backToMain, pageName: 'excellentEmployeePage' });

  const loading = !userList || isLoading;

  return (
    <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
      <Root loading={loading} className={size.innerSize.W > 1024 || viewTable ? 'showRoot' : 'hideRoot'}>
        <List
          data={userList}
          isLoading={loading}
          isError={isError}
          tableState={tableState}
          setTableState={setTableState}
          setRowState={setRowState}
          isNewAdd={isNewAdd}
          setIsNewAdd={setIsNewAdd}
          addBtnAction={addBtnAction}
        />
      </Root>
      {(size.innerSize.W > 1024 || !viewTable) && (
        <Root loading={loading}>
          <div className='inputFormsWrapper flexRowEm'>
            {size.innerSize.W <= 1024 && <BackButton func={onBackPrev} />}
            <div className='formTitle'>{isNewAdd ? t('새로운 우수사원') : t('사원 정보')}</div>
          </div>
          <Form rowState={rowState} setRowState={setRowState} isNewAdd={isNewAdd} setIsNewAdd={setIsNewAdd} setTableState={setTableState} refetch={refetch} />
        </Root>
      )}
    </div>
  );
};

export default ExcellentEmployee;
